import { render, staticRenderFns } from "./question-05.vue?vue&type=template&id=4a842f28&scoped=true&lang=pug"
var script = {}
import style0 from "./question-05.vue?vue&type=style&index=0&id=4a842f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a842f28",
  null
  
)

export default component.exports